"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimizePeaks = void 0;
const ml_spectra_processing_1 = require("ml-spectra-processing");
const nmr_processing_1 = require("nmr-processing");
function optimizePeaks(spectrum, options) {
    const { from, to, peaks } = options;
    const { originFrequency: frequency } = spectrum.info;
    let { re, x } = spectrum.data;
    const fromIndex = (0, ml_spectra_processing_1.xFindClosestIndex)(x, from);
    const ToIndex = (0, ml_spectra_processing_1.xFindClosestIndex)(x, to);
    // create deleted peaks object where the key is the id of the peaks that we need to remove
    const ids = {};
    for (const peak of peaks) {
        ids[peak.id] = peak;
    }
    //remove peaks before start the optimization from the original list
    spectrum.peaks.values = spectrum.peaks.values.filter((peak) => !ids[peak.id]);
    x = x.subarray(fromIndex, ToIndex);
    re = re.subarray(fromIndex, ToIndex);
    const newPeaks = (0, nmr_processing_1.xyPeaksOptimization)({ x, y: re }, peaks, {
        frequency,
        groupingFactor: 3,
    });
    return (0, nmr_processing_1.mapPeaks)(spectrum.peaks.values.concat(newPeaks), spectrum, {
        checkIsExisting: false,
    });
}
exports.optimizePeaks = optimizePeaks;
